import React from "react";
import { Box, Grid2 } from "@mui/material";
import { ComparisonChart, HistoricalQuotesChart } from "@components";
import { LoadingPlaceHolder } from "@rentablo/components";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsChart } from "../DividendsChart/DividendsChart";
import { DetailInformation } from "../DetailInformation/DetailInformation";
import { useDividendsPerYear } from "../../hooks/useDividendsPerYear";
import { useFundamental } from "../../hooks/useFundamental";
import { GainLossStatisticsLoader } from "../../../watchlists/details/GainLossStatisticsLoader";
import { useFundamentalsContext } from "../../FundamentalsContext";

export const SecurityFundamentalsByIsin = ({
  watchlistEntryId,
  isin,
  quoteProvider,
  tickerSymbol,
}: {
  watchlistEntryId?: number;
  quoteProvider: string;
  tickerSymbol: string;
  isin: string;
}) => {
  const { data: dividends, isLoading: isDividendsLoading } =
    useDividendsPerYear(isin);
  const { data: security, isLoading: isSecurityLoading } = useFundamental(isin);

  const areDividendsPresent = dividends && dividends?.length > 0;
  const isSecurityPresent = !!security;

  const { selectedMetrics, hideMetric, changeMetric, isLoading } =
    useFundamentalsContext();

  if (isLoading || isDividendsLoading || isSecurityLoading) {
    return (
      <Box mt={6}>
        <LoadingPlaceHolder />
      </Box>
    );
  }

  return (
    <Grid2 container spacing={4} width="100%" sx={{ mt: 5 }}>
      {watchlistEntryId && (
        <FundamentalsCard>
          <GainLossStatisticsLoader watchlistEntryId={watchlistEntryId} />
        </FundamentalsCard>
      )}

      {isSecurityPresent && (
        <FundamentalsCard>
          <DetailInformation
            isin={isin}
            quoteProvider={quoteProvider}
            tickerSymbol={tickerSymbol}
            currency="EUR"
          />
        </FundamentalsCard>
      )}

      {areDividendsPresent && (
        <FundamentalsCard hideFor={["kpmg-germany"]}>
          <DividendsChart isin={isin} currency="EUR" />
        </FundamentalsCard>
      )}

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <HistoricalQuotesChart
          quoteProvider={quoteProvider}
          tickerSymbol={tickerSymbol}
        />
      </FundamentalsCard>

      {selectedMetrics.map((value) => (
        <FundamentalsCard hideFor={["kpmg-germany"]} key={value.mainMetricKey}>
          <ComparisonChart
            isin={isin}
            quoteProvider={quoteProvider}
            tickerSymbol={tickerSymbol}
            defaultValue={value}
            mainMetricKey={value.mainMetricKey}
            onHide={() => hideMetric(value.mainMetricKey)}
            onChange={(secondValue) =>
              changeMetric(value.mainMetricKey, secondValue)
            }
          />
        </FundamentalsCard>
      ))}
    </Grid2>
  );
};
